import React from "react";

import TrashImage from "../../../assets/result/result-a.png";

import ResultPageLayout from "../ResultPageLayout";

const ResultPage1 = () => {
  return (
    <ResultPageLayout
      img={TrashImage}
      title="노력하는 환경러!"
      hashText="2주는_거뜬히_버틸수도"
    >
      당신은 이미 환경을 생각하며
      <br />
      쓰레기를 줄이기 위해
      <br />
      텀블러를 챙기고 다니는 등<br />
      다양한 노력을 하고 있습니다.
      <br />
      이 정도 정성이면 쓰레기통 없이
      <br />
      <b>2주일</b>은 버틸 수 있겠군요.
      <br />
      <br />
      마트에서 장 볼 때마다 포장용지가 거슬리고,
      <br />
      ‘카페 키오스크에 텀블러 옵션이 더 있었다면!’
      <br />
      하고 생각하진 않으셨나요?
      <br />
      <br />
      환경을 위해 <b>개인, 정책, 기업</b>
      <br />
      모두 힘을 합쳐야 하는 지금.
      <br />
      <br />
      우리 시민들의 노력이 극대화되기 위해
      <br />
      어떤 정책이 있으면 좋을까요?
      <br />
      <br />
      환경러님의 환경을 생각하는 정책,
      <br />
      혹은 쓰레기 줄이기에 <b>유용한 의견을 남겨주세요!</b>
    </ResultPageLayout>
  );
};

export default ResultPage1;
